<template>
    <v-container grid-list-md text-center>
        <v-layout wrap>
            <v-flex xs12>
                <v-card color="grey lighten-5" class="mb-10" height="auto">
                    <v-card-title>
                        <h5>Onduleurs :</h5>
                        <v-spacer></v-spacer>
                        <v-text-field
                            v-model="$store.state.searchInvertersList"
                            append-icon="mdi-magnify"
                            label="Recherche"
                            single-line
                            hide-details>
                        </v-text-field>															
                    </v-card-title>
                    <v-data-table
                        :headers="$store.state.InvertersHeaders"
                        :items="$store.state.invertersListBool"
                        :items-per-page="15"
                        :single-select="true"
                        :search="$store.state.searchInvertersList"
                        :dense = true
                        item-key="ID"
                        class="elevation-1"
                    >
                        <template v-slot:top>
                            <v-toolbar
                                flat
                            >
                                <v-spacer></v-spacer>
                                <v-dialog
                                    v-model="dialogEdit"
                                    max-width="1200px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            color="primary"
                                            dark
                                            class="mb-1"
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            +
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-title>
                                            <span class="text-h5">{{ formTitle }}</span>
                                        </v-card-title>
                                        <FormulaireOnduleurs></FormulaireOnduleurs>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                color="blue darken-1"
                                                text
                                                @click="closeEdit"
                                            >
                                                Annuler
                                            </v-btn>
                                            <v-btn v-if="$store.state.invertersEditedItem.REFERENCE != '' && 
                                                         $store.state.invertersEditedItem.SOG_TYPE != '' && 
                                                         $store.state.invertersEditedItem.POWER > 0 && 
                                                         $store.state.invertersEditedItem.PHASES > 0" 
                                                         color="blue darken-1"
                                                text
                                                @click="saveEdit"
                                            >
                                                Enregistrer
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                                <v-dialog
                                    v-model="dialogCopy"
                                    max-width="1200px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                    </template>
                                    <v-card>
                                        <v-card-title>
                                            <span class="text-h5">Copier l'onduleur</span>
                                        </v-card-title>
                                        <FormulaireOnduleurs></FormulaireOnduleurs>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                color="blue darken-1"
                                                text
                                                @click="closeCopy"
                                            >
                                                Annuler
                                            </v-btn>
                                            <v-btn v-if="$store.state.invertersEditedItem.REFERENCE != '' && 
                                                         $store.state.invertersEditedItem.SOG_TYPE != '' && 
                                                         $store.state.invertersEditedItem.POWER > 0 && 
                                                         $store.state.invertersEditedItem.PHASES > 0" 
                                                         color="blue darken-1"
                                                text
                                                @click="saveCopy"
                                            >
                                                Ajouter
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                                <v-dialog v-model="dialogDelete" max-width="500px">
                                    <v-card>
                                        <v-card-title class="text-h5">Voulez-vous supprimer cet onduleur ?</v-card-title>
                                        <v-card-text>
                                            {{ $store.state.invertersEditedItem.REFERENCE }} {{ $store.state.invertersEditedItem.DESC_FR }}
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn color="blue darken-1" text @click="closeDelete">Annuler</v-btn>
                                            <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                                            <v-spacer></v-spacer>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-toolbar>
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <v-icon
                                small
                                class="mr-2"
                                @click="copyItem(item)"
                            >
                                mdi-content-copy
                            </v-icon>
                            <v-icon
                                small
                                class="mr-2"
                                @click="editItem(item)"
                            >
                                mdi-pencil
                            </v-icon>
                            <v-icon
                                small
                                class="mr-2"
                                @click="deleteItem(item)"
                            >
                                mdi-delete
                            </v-icon>
                        </template>
                        <template v-slot:item.DELTA_COMPATIBLE="{ item }">
                            <v-simple-checkbox
                                v-model="item.DELTA_COMPATIBLE"
                                disabled
                            ></v-simple-checkbox>
                        </template>
                        <template v-slot:item.EXTENDED="{ item }">
                            <v-simple-checkbox
                                v-model="item.EXTENDED"
                                disabled
                            ></v-simple-checkbox>
                        </template>
                        <template v-slot:item.STOREDGE="{ item }">
                            <v-simple-checkbox
                                v-model="item.STOREDGE"
                                disabled
                            ></v-simple-checkbox>
                        </template>
                        <template v-slot:item.EV="{ item }">
                            <v-simple-checkbox
                                v-model="item.EV"
                                disabled
                            ></v-simple-checkbox>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
	import axios from 'axios';
    import createListBoolMixins from './mixins/createListBoolMixins.js';
	import FormulaireOnduleurs from './FormulaireOnduleurs.vue';

	export default {
    name: "GestionOnduleurs",
    components: { FormulaireOnduleurs },
    mixins: [
        createListBoolMixins,
    ],
    data: function () {
        return {
            dialogEdit: false,
            dialogCopy: false,
            dialogDelete: false,
            editedIndex: -1,
            formHasErrors: false,
            defaultItem: {
                REFERENCE: '',
                EXTENSION_REFERENCE: '',
                EXTENSION_QUANTITY: '',
                DESC_NL: '',
                DESC_FR: '',
                SOG_TYPE: '',
                POWER: '',
                PHASES: 1,
                DELTA_COMPATIBLE: false,
                EXTENDED: false,
                STOREDGE: false,
                EV: false,
                STRING_INPUTS: 0,
            },
        };
    },
    computed: {
        formTitle() {
            return this.editedIndex === -1 ? "Nouvel onduleur" : "Modifier l'onduleur";
        },
    },
    watch: {
        dialogEdit(val) {
            val || this.closeEdit();
        },
        dialogCopy(val) {
            val || this.closeCopy();
        },
        dialogDelete(val) {
            val || this.closeDelete();
        },
    },
    mounted() {
        this.createInvertersListBool();
    },
    methods: {
        getColor(admin) {
            if (admin == 0)
                return "red";
            else
                return "green";
        },
        editItem(item) {
            this.editedIndex = this.$store.state.invertersListBool.indexOf(item);
            this.$store.state.invertersEditedItem = Object.assign({}, item);
            this.dialogEdit = true;
        },
        copyItem(item) {
            this.editedIndex = this.$store.state.invertersListBool.indexOf(item);
            this.$store.state.invertersEditedItem = Object.assign({}, item);
            this.dialogCopy = true;
        },
        deleteItem(item) {
            this.editedIndex = this.$store.state.invertersListBool.indexOf(item);
            this.$store.state.invertersEditedItem = Object.assign({}, item);
            this.dialogDelete = true;
        },
        deleteItemConfirm() {
            this.$store.state.invertersListBool.splice(this.editedIndex, 1);
            this.closeDelete();
            var link = "http://3ur4p2zmartexkth.servebeer.com/domoserverDb/deleteInverter.php";
            this.$store.state.axios_error = "";
            var data = this.$store.state.invertersEditedItem.ID;
            axios.post(link, data, {
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(response => {
                this.$store.state.invertersResponse = response;
                this.$store.state.api_status = response.data.api_status;
                this.$store.state.axios_error = "";
                if (response.data.invertersListSaved) {
                    link = "http://3ur4p2zmartexkth.servebeer.com/domoserverDb/loadInvertersList.php";
                    axios.get(link).then(response => {
                        this.$store.state.invertersList = response.data;
                        this.createInvertersListBool();
                    });
                }
            }).catch((error) => {
                this.$store.state.axios_error = error;
            });
        },
        closeEdit() {
            this.dialogEdit = false;
            this.$nextTick(() => {
                this.$store.state.invertersEditedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },
        closeCopy() {
            this.dialogCopy = false;
            this.$nextTick(() => {
                this.$store.state.invertersEditedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },
        closeDelete() {
            this.dialogDelete = false;
            this.$nextTick(() => {
                this.$store.state.invertersEditedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },
        saveEdit() {
            if (this.editedIndex > -1) {
                Object.assign(this.$store.state.invertersListBool[this.editedIndex], this.$store.state.invertersEditedItem);
                var link = "http://3ur4p2zmartexkth.servebeer.com/domoserverDb/editInverter.php";
            }
            else {
                this.$store.state.invertersListBool.push(this.$store.state.invertersEditedItem);
                link = "http://3ur4p2zmartexkth.servebeer.com/domoserverDb/addInverter.php";
            }
            this.closeEdit();
            this.$store.state.axios_error = "";
            var data = this.$store.state.invertersEditedItem;
            axios.post(link, data, {
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(response => {
                this.$store.state.invertersResponse = response;
                this.$store.state.api_status = response.data.api_status;
                this.$store.state.axios_error = "";
                if (response.data.invertersListSaved) {
                    link = "http://3ur4p2zmartexkth.servebeer.com/domoserverDb/loadInvertersList.php";
                    axios.get(link).then(response => {
                        this.$store.state.invertersList = response.data;
                        this.createInvertersListBool();
                    });
                }
            }).catch((error) => {
                this.$store.state.axios_error = error;
            });
        },
        saveCopy() {
            this.closeCopy();
            var link = "http://3ur4p2zmartexkth.servebeer.com/domoserverDb/addInverter.php";
            this.$store.state.axios_error = "";
            var data = this.$store.state.invertersEditedItem;
            axios.post(link, data, {
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(response => {
                this.$store.state.invertersResponse = response;
                this.$store.state.api_status = response.data.api_status;
                this.$store.state.axios_error = "";
                if (response.data.invertersListSaved) {
                    link = "http://3ur4p2zmartexkth.servebeer.com/domoserverDb/loadInvertersList.php";
                    axios.get(link).then(response => {
                        this.$store.state.invertersList = response.data;
                        this.createInvertersListBool();
                    });
                }
            }).catch((error) => {
                this.$store.state.axios_error = error;
            });
        },
    },
}
</script>
